module.exports = __webpack_public_path__ + "img/5.231670ad.webp";